import React from 'react';
import Case from 'case';
import { Box, Text } from 'grommet';
import PropTypes from 'prop-types';
import {
  MANUAL_CLAIM_REQUEST_STATUS,
  MANUAL_CLAIM_ITEM_STATUS,
} from './manualClaimConstants';

/**
 * Theme-aware status pill for manual claim request rows (customer + admin).
 */
export function ManualClaimStatusPill({ status, page }) {
  const raw = String(status || '').toLowerCase();
  let bg = page.tableBg;
  let color = page.tableText;
  let border = page.tableBorder;

  if (raw === MANUAL_CLAIM_ITEM_STATUS.REJECTED) {
    bg = page.statusError;
    color = '#FFFFFF';
    border = page.statusError;
  } else if (
    raw === MANUAL_CLAIM_REQUEST_STATUS.COMPLETED
    || raw === MANUAL_CLAIM_ITEM_STATUS.MONETIZED
    || raw === MANUAL_CLAIM_ITEM_STATUS.TAKENDOWN
  ) {
    bg = page.statusSuccess;
    color = '#FFFFFF';
    border = page.statusSuccess;
  } else if (
    raw === MANUAL_CLAIM_REQUEST_STATUS.CLAIM_REQUESTED
    || raw === MANUAL_CLAIM_REQUEST_STATUS.UNDER_REVIEW
    || raw === MANUAL_CLAIM_ITEM_STATUS.PENDING
  ) {
    bg = page.inputBg;
    color = page.primaryText;
    border = page.inputBorder;
  }

  const label = status
    ? Case.title(String(status).replace(/_/g, ' '))
    : '—';

  return (
    <Box
      background={bg}
      border={{ color: border, size: '1px' }}
      round="6px"
      pad={{ vertical: '0.2rem', horizontal: '0.5rem' }}
      width="fit-content"
    >
      <Text size="0.8rem" weight={600} color={color}>
        {label}
      </Text>
    </Box>
  );
}

ManualClaimStatusPill.propTypes = {
  status: PropTypes.string,
  page: PropTypes.shape({
    tableBg: PropTypes.string.isRequired,
    tableText: PropTypes.string.isRequired,
    tableBorder: PropTypes.string.isRequired,
    statusError: PropTypes.string.isRequired,
    statusSuccess: PropTypes.string.isRequired,
    inputBg: PropTypes.string.isRequired,
    primaryText: PropTypes.string.isRequired,
    inputBorder: PropTypes.string.isRequired,
  }).isRequired,
};

export default ManualClaimStatusPill;
